import {useEffect, useState} from "react";
import ContainerComponent from "../../../components/elements/ContainerComponent";
import {TableWithStripedRows} from "../../../components/elements/Tables/TableComponent";

export function ProveedoresList(props) {
  const [didMount, setDidMount] = useState(false);
  const {list} = props;

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    if (didMount) {
      list();
    }
  }, [didMount, list]);

  const columnsName = [
    {
      selector: row => row.id,
      name: 'id',
    },
    {
      selector: row => row.person.names,
      name: 'Nombres',
    },
    {
      selector: row => row.person.last_names,
      name: 'Apellidos',
    },
    {
      selector: row => row.person.phone_number,
      name: 'Teléfono',
    },
    {
      selector: row => row.person.nit,
      name: 'NIT',
    },
  ]

  return (
    <ContainerComponent
      uri={'crear'}
      title="Proveedores"
      textBtnCreate={'Crear Proveedor'}
    >
      <TableWithStripedRows
        {...props}
        titleExcel="Proveedores"
        columns={columnsName}
        actionDelete={props.deleteRecord}
        searchChange={props.searchChange}
        searchValue={props.search}
      />
    </ContainerComponent>
  )

}